import React, { memo } from "react";
// Libraries
import cn from "classnames";
// Components
import { Input } from "components";
// Resources
import inputStyles from "../Input/Input.module.scss";

type BaseInput = InputNumberProps | InputPasswordProps | InputTextProps;

export const BaseInput: React.FC<BaseInput> = memo(
  ({ adornment, name, hasError, innerRef, validation, onChange, ...props }) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
      const value = e.target.value;

      if (validation && value !== "") {
        const isValidValue = validation.test(value);

        if (isValidValue) {
          onChange(e);
        }
      } else {
        onChange(e);
      }
    };

    return (
      <Input hasError={hasError} adornment={adornment}>
        <input
          className={cn(inputStyles.input__native, inputStyles["input__native--text"])}
          id={name}
          name={name}
          ref={innerRef}
          onChange={handleInputChange}
          {...props}
        />
      </Input>
    );
  },
);
BaseInput.displayName = "BaseInput";
